/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ArticleWithTopics } from '../../models/article-with-topics';

export interface GetArticle$Params {
  id: string;
}

export function getArticle(http: HttpClient, rootUrl: string, params: GetArticle$Params, context?: HttpContext): Observable<StrictHttpResponse<ArticleWithTopics>> {
  const rb = new RequestBuilder(rootUrl, getArticle.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {"style":"simple"});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ArticleWithTopics>;
    })
  );
}

getArticle.PATH = '/v0/articles/{id}';
